"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutomaticUpdates = void 0;
const react_1 = require("react");
const capacitor_updater_1 = require("@capgo/capacitor-updater");
const dialog_1 = require("@capacitor/dialog");
const splash_screen_1 = require("@capacitor/splash-screen");
const core_1 = require("@capacitor/core");
const useAutomaticUpdates = () => {
    const [updateCounter, setUpdateCounter] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (core_1.Capacitor.getPlatform() !== 'web') {
            if (process.env.NODE_ENV !== 'production') {
                console.log('Env is not production, setting capgo channel to dev: ' +
                    process.env.NODE_ENV);
                capacitor_updater_1.CapacitorUpdater.setChannel({
                    channel: 'dev',
                    triggerAutoUpdate: true,
                });
            }
            const handleUpdateAvailable = (res) => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    if (updateCounter > 0) {
                        // Event has already been handled, do nothing.
                        return;
                    }
                    yield dialog_1.Dialog.alert({
                        title: 'Update Available',
                        message: `Your app will be updated to the latest version (${res.bundle.version})`,
                    });
                    capacitor_updater_1.CapacitorUpdater.set(res.bundle);
                    splash_screen_1.SplashScreen.show({
                        showDuration: 2000,
                        autoHide: true,
                    });
                    setUpdateCounter((prevCounter) => prevCounter + 1);
                }
                catch (error) {
                    console.log(error);
                }
            });
            // Add the event listener
            capacitor_updater_1.CapacitorUpdater.addListener('updateAvailable', handleUpdateAvailable);
            // Notify app ready
            capacitor_updater_1.CapacitorUpdater.notifyAppReady();
            // Clean up by removing the event listener when the component unmounts
            return () => {
                capacitor_updater_1.CapacitorUpdater.removeAllListeners();
            };
        }
    }, [updateCounter]);
};
exports.useAutomaticUpdates = useAutomaticUpdates;
//# sourceMappingURL=useAutomaticUpdates.js.map